import React from 'react';
import { useNavigate } from "react-router-dom";
const DisplayProjects = ({ project }) => {
    const { id, name, desc, img, livesite } = project;
    let navigate = useNavigate();
    const handleClick = () => {
        navigate(`/details/${id}`)

    }

    return (
        <div>
            <div className="card mb-5" style={{ maxWidth: '640px' }}>
                <div className="row row-cols-1 row-cols-md-12   g-4">
                    <div className="col">
                        <div class="card">
                            <img src={img} height="100px" class="img-fluid" alt="..." />
                            <div class="card-body">
                                <h5 class="card-title">{name}</h5>
                                <p class="card-text">{desc}</p>
                            </div>
                            <a href={livesite} target="_blank"
                                rel="noopener noreferrer"><button type="button" className="btn btn-success my-2 ">Live Site</button></a>
                            <span>  <button type="button" className="btn btn-success my-2 pe-3" onClick={handleClick}>Details</button></span>
                        </div>
                    </div>
                </div>
            </div>

        </div >
    );
};

export default DisplayProjects;